import React, { useEffect, useState } from 'react'
import FirmMain from './FirmMain'
import { Form, Input, Button, Space, message } from 'antd'
import { useYonghuUpdatemimaCodeMutation, useYonghuUpdatemimaMutation } from '../store/ReactWebSiteApi'
import { useSelector } from 'react-redux'
const COUNTDOWN_SEC = 60
function FirmPassword() {
    const [form] = Form.useForm()
    const code = Form.useWatch('code', form)
    const firmLogin = useSelector((state) => state.firmLogin)
    const [getCode, { isLoading: isCodeLoading }] = useYonghuUpdatemimaCodeMutation()
    const [submit, { isLoading: isSubmitLoading }] = useYonghuUpdatemimaMutation()
    const [countdown, setCountdown] = useState(0)
    const phone = firmLogin?.byxkh_yh_phone || '--'
    const codeOk = typeof code === 'string' && /^\d{6}$/.test(code)
    const submitDisabled = !codeOk || isSubmitLoading
    useEffect(() => {
        if (countdown <= 0) return undefined
        const id = setInterval(() => {
            setCountdown((c) => (c <= 1 ? 0 : c - 1))
        }, 1000)
        return () => clearInterval(id)
    }, [countdown])



    const handleSubmit = () => {

        if (isSubmitLoading) return

        submit({

            byxkh_yh_phone: phone,

            phone_code: form.getFieldValue('code'),

            byxkh_yh_password: form.getFieldValue('newPassword'),

        })

            .unwrap()

            .then((res) => {

                console.log(res)

                message.success('修改密码已成功！')

            })

            .catch(() => {})

    }



    const getCodeBtn = () => {

        if (countdown > 0) {

            message.warning('请勿重复点击！')

            return

        }

        if (isCodeLoading) return

        getCode({ phone })

            .unwrap()

            .then(() => {

                setCountdown(COUNTDOWN_SEC)

            })

            .catch(() => {})

    }



    return (

        <FirmMain leftSelectedKeys='password'>

            <div style={{ width: '400px', marginLeft: '100px' }}>

                <h1>修改密码</h1>

                <Form

                    form={form}

                    onFinish={handleSubmit}

                    labelCol={{ span: 6 }}

                    wrapperCol={{ span: 14 }}

                >

                    <Form.Item label='新密码' name='newPassword'>

                        <Input />

                    </Form.Item>

                    <Form.Item label='确认密码' name='confirmPassword'>

                        <Input />

                    </Form.Item>

                    <Form.Item label='手机号码' name='phone'>

                        <Input disabled value={phone} />

                    </Form.Item>

                    <Form.Item

                        label='验证码'

                        name='code'

                        normalize={(v) => (typeof v === 'string' ? v.replace(/\D/g, '').slice(0, 6) : v)}

                    >

                        <Space>

                            <Input maxLength={6} inputMode='numeric' placeholder='请输入6位数字' />

                            <Button

                                type='primary'

                                htmlType='button'

                                loading={isCodeLoading}

                                onClick={getCodeBtn}

                            >

                                {countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码'}

                            </Button>

                        </Space>

                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 6, span: 14 }}>

                        <Button type='primary' htmlType='submit' disabled={submitDisabled} loading={isSubmitLoading}>

                            提交

                        </Button>

                    </Form.Item>

                </Form>

            </div>

        </FirmMain>

    )

}



export default FirmPassword

